//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import localizableFormat from 'dayjs-ext/plugin/localizableFormat';
import analyticEvents from '~/services/analyticEvents';
import { ARTICLE_TYPE } from '~/static/constants';
dayjs.extend(localizableFormat);

export default {
    name: 'SuggestedArticles',

    inject: ['blogTopic'],
    props: {
        articles: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            formattedRelatedArticles: null,
            articleMaxLength: 66,
            hoveredArticleIndex: -1
        };
    },
    mounted() {
        this.formattedRelatedArticles = this.articles
            .filter((item) => item.data.title)
            .map((item) => this.formatBlogData(item));
    },
    methods: {
        getFormattedArticleTitle(title, index) {
            return title.length >= this.articleMaxLength &&
                this.hoveredArticleIndex !== index &&
                this.$device.isDesktop
                ? title.substr(0, this.articleMaxLength) + '...'
                : title;
        },
        formatBlogData(data) {
            const blogData = {
                type: ARTICLE_TYPE.BLOG,
                slug: null,
                topic: null,
                tableOfContentList: null,
                articleContent: null,
                faqSchemaStructure: null,
                articleSchemaStructure: null,
                metaTitle: null,
                metaDescription: null,
                // Specific information for Blog Cards.
                metaInformation: null
            };

            // SEAL
            Object.seal(blogData);
            blogData.slug = `/${this.blogTopic}/${data.slug}`;
            blogData.metaInformation = {
                title: data.data.title,
                subTitle: data.data.metadesc,
                duration: data.data.read_time + ' mins',
                timestamp: dayjs(data.updated_at).format('MMM D, YYYY'),
                imageUrl: data.data.image_url
                    ? '/images/articles/' + data.data.image_url
                    : '/images/articles/1680247840672_topic_q2_2.png'
            };

            return blogData;
        },
        onCardClick(blogSlugRoute) {
            const trackingEvent = {
                event: analyticEvents.related_discussion_clicked,
                data: {
                    exam_name: this.blogTopic.toUpperCase(),
                    source_url: `${window.location.origin}${this.$route.path}`,
                    blog_url: `${window.location.origin}${blogSlugRoute}`
                }
            };
            this.$store.dispatch('analytics/trackEvent', trackingEvent);
            this.$router.push(blogSlugRoute);
        }
    }
};
